import { Alert, Divider, Grid } from '@mui/material';

import { Link } from '~/components/Link';
import { ReportImage } from '~/components/ReportImage';
import useSuggestionsQuery from '~/hooks/useSuggestionsQuery';
import { isSingleCodeSearch } from '~/scripts/isSingleCodeSearch';
import type { Searches } from '~/types/searches';

interface DidYouMeanProps {
  search: Searches.SearchObject;
}

const DidYouMean = ({ search }: DidYouMeanProps) => {
  const suggestions = useSuggestionsQuery(
    isSingleCodeSearch(search) ? search.all?.[0]?.value || '' : ''
  );

  if (!isSingleCodeSearch(search)) {
    return null;
  }

  if (!suggestions.data || suggestions.isLoading || suggestions.isError) {
    return null;
  }

  const suggestion = suggestions.data[0];
  if (!suggestion) {
    return null;
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sx={{ p: 0, m: 0 }}>
        <Alert
          severity="info"
          sx={{ m: 0, alignItems: 'center' }}
          component={(props) => (
            <Link href={suggestion.url} variant="h5" {...props} />
          )}
          icon={
            <ReportImage
              uuid={suggestion.uuid}
              width={50}
              height={50}
              sx={{ objectFit: 'contain' }}
            />
          }>
          Looking for {suggestion.name}? Click here for our more accurate
          report.
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default DidYouMean;
